<kt-splash-screen></kt-splash-screen>
<app-loading *ngIf="loading"></app-loading>
<router-outlet></router-outlet>
